/* istanbul ignore file */
import { useState, useRef, useEffect } from 'react';
import FocusTrap from 'focus-trap-react';

const withFocusTrap =
  (shouldTrapFocus = () => true, options = {}) =>
  (WrappedComponent) => {
    function WithFocusTrap(props) {
      const [isFocusTrapped, setIsFocusTrapped] = useState(shouldTrapFocus(props));
      const rootElement = useRef(null);

      useEffect(() => {
        setIsFocusTrapped(shouldTrapFocus(props));
      }, [props]);

      return (
        <FocusTrap
          active={isFocusTrapped}
          focusTrapOptions={{
            clickOutsideDeactivates: true,
            fallbackFocus: () => rootElement.current,
            initialFocus: () => rootElement.current,
            ...options,
          }}
        >
          <div ref={rootElement}>
            <WrappedComponent {...props} />
          </div>
        </FocusTrap>
      );
    }

    WithFocusTrap.displayName = `WithFocusTrap${
      WrappedComponent.displayName || WrappedComponent.name
    }`;

    return WithFocusTrap;
  };

export default withFocusTrap;
